import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=64570cd6&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=64570cd6&prod&scoped=true&lang=css&"
import style1 from "./Home.vue?vue&type=style&index=1&id=64570cd6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64570cd6",
  null
  
)

export default component.exports